module.exports = __webpack_public_path__ + "img/depoimentos4.2e13b379.jpg";